import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function CTA() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 relative overflow-hidden bg-svt-bg-alt transition-colors duration-300" data-id="element-35">
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03] pointer-events-none" data-id="element-36"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-svt-pink/20 to-transparent rounded-full blur-[80px] pointer-events-none" data-id="element-37"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center relative" data-id="element-39">
          <div className="absolute inset-0 bg-gradient-to-r from-svt-pink/20 via-svt-purple/20 to-svt-pink/20 rounded-3xl blur-md" data-id="element-40"></div>

          <div className="relative bg-svt-card/80 backdrop-blur-xl border border-svt-border p-12 md:p-20 rounded-3xl transition-colors duration-300" data-id="element-41">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight text-svt-text" data-id="element-42">
              {t('cta.title1')} <br data-id="element-43" />{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-44">
                {t('cta.title2')}
              </span>
            </h2>
            <p className="text-lg md:text-xl text-svt-text-secondary mb-12 font-light max-w-2xl mx-auto" data-id="element-45">
              {t('cta.subtitle')}
            </p>

            <div className="flex justify-center gap-6 mb-12" data-id="element-46">
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: 0
            }} data-id="element-47">
                <span className="text-svt-pink text-3xl drop-shadow-[0_0_10px_rgba(232,67,147,0.5)]" data-id="element-48">
                  ♥
                </span>
              </motion.div>
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: 0.3
            }} data-id="element-49">
                <span className="text-svt-purple text-4xl drop-shadow-[0_0_10px_rgba(168,85,247,0.5)]" data-id="element-50">
                  ♥
                </span>
              </motion.div>
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: 0.6
            }} data-id="element-51">
                <span className="text-svt-pink-light text-3xl drop-shadow-[0_0_10px_rgba(253,121,168,0.5)]" data-id="element-52">
                  ♥
                </span>
              </motion.div>
            </div>

            <button className="px-14 py-5 rounded-full bg-gradient-primary text-white font-bold text-lg hover:opacity-90 transition-all shadow-[0_0_40px_rgba(232,67,147,0.4)] hover:shadow-[0_0_60px_rgba(232,67,147,0.6)] transform hover:-translate-y-1" data-id="element-53">
              {t('cta.button')}
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}